import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: 'خصم 30% على جميع المنتجات',
      subtitle: 'عرض لفترة محدودة',
      bg: 'https://public.readdy.ai/ai/img_res/138da6245b718dac682b24c5883266c3.jpg'
    },
    {
      title: 'توصيل مجاني للطلبات فوق 200 ر.س',
      subtitle: 'اطلب الآن واستمتع بالتوصيل المجاني',
      bg: 'https://readdy.ai/api/search-image?query=delivery%20truck%20with%20grocery%20boxes%2C%20fast%20shipping%20concept%2C%20professional%20photography%2C%20modern%20logistics%2C%20clean%20background%2C%20bright%20daylight%2C%20high%20quality%20commercial%20photo&width=375&height=180&seq=slide2&orientation=landscape'
    },
    {
      title: 'منتجات طازجة يومياً',
      subtitle: 'جودة عالية وأسعار منافسة',
      bg: 'https://readdy.ai/api/search-image?query=fresh%20organic%20products%20display%2C%20colorful%20vegetables%20and%20fruits%20arrangement%2C%20supermarket%20quality%2C%20professional%20food%20photography%2C%20clean%20white%20background%2C%20vibrant%20colors&width=375&height=180&seq=slide3&orientation=landscape'
    }
  ];

  const categories = [
    { name: 'بقالات', icon: 'ri-shopping-basket-line', color: 'from-orange-400 to-orange-500', image: 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20grocery%20items%20including%20rice%20bags%20and%20canned%20goods%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look%2C%20single%20object%20focus&width=100&height=100&seq=cat1&orientation=squarish' },
    { name: 'مشروبات', icon: 'ri-cup-line', color: 'from-blue-400 to-blue-500', image: 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20beverage%20bottles%20and%20juice%20cartons%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look%2C%20single%20object%20focus&width=100&height=100&seq=cat2&orientation=squarish' },
    { name: 'منظفات', icon: 'ri-drop-line', color: 'from-green-400 to-green-500', image: 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20cleaning%20products%20and%20detergent%20bottles%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look%2C%20single%20object%20focus&width=100&height=100&seq=cat3&orientation=squarish' },
    { name: 'مجمدات', icon: 'ri-fridge-line', color: 'from-cyan-400 to-cyan-500', image: 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20frozen%20food%20packages%20and%20ice%20cream%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look%2C%20single%20object%20focus&width=100&height=100&seq=cat4&orientation=squarish' },
    { name: 'عروض الجملة', icon: 'ri-box-3-line', color: 'from-purple-400 to-purple-500', image: 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20wholesale%20boxes%20and%20bulk%20packages%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look%2C%20single%20object%20focus&width=100&height=100&seq=cat5&orientation=squarish' },
    { name: 'خضروات', icon: 'ri-leaf-line', color: 'from-lime-400 to-lime-500', image: 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20fresh%20vegetables%20including%20tomatoes%20and%20carrots%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look%2C%20single%20object%20focus&width=100&height=100&seq=cat6&orientation=squarish' }
  ];

  const products = [
    { id: 1, name: 'أرز بسمتي هندي', price: 45, image: 'https://readdy.ai/api/search-image?query=premium%20basmati%20rice%20bag%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20high%20quality%20commercial%20photo%2C%20centered%20composition%2C%20soft%20lighting%2C%20realistic%20details&width=200&height=200&seq=prod1&orientation=squarish', rating: 4.8, sales: 1250 },
    { id: 2, name: 'زيت زيتون بكر', price: 89, image: 'https://readdy.ai/api/search-image?query=extra%20virgin%20olive%20oil%20bottle%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20high%20quality%20commercial%20photo%2C%20centered%20composition%2C%20soft%20lighting%2C%20realistic%20details&width=200&height=200&seq=prod2&orientation=squarish', rating: 4.9, sales: 890 },
    { id: 3, name: 'حليب طازج كامل الدسم', price: 18, image: 'https://readdy.ai/api/search-image?query=fresh%20whole%20milk%20carton%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20high%20quality%20commercial%20photo%2C%20centered%20composition%2C%20soft%20lighting%2C%20realistic%20details&width=200&height=200&seq=prod3&orientation=squarish', rating: 4.7, sales: 2100 },
    { id: 4, name: 'معكرونة إيطالية', price: 12, image: 'https://readdy.ai/api/search-image?query=italian%20pasta%20package%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20high%20quality%20commercial%20photo%2C%20centered%20composition%2C%20soft%20lighting%2C%20realistic%20details&width=200&height=200&seq=prod4&orientation=squarish', rating: 4.6, sales: 1580 },
    { id: 5, name: 'صلصة طماطم', price: 8, image: 'https://readdy.ai/api/search-image?query=tomato%20sauce%20can%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20high%20quality%20commercial%20photo%2C%20centered%20composition%2C%20soft%20lighting%2C%20realistic%20details&width=200&height=200&seq=prod5&orientation=squarish', rating: 4.5, sales: 1920 },
    { id: 6, name: 'شاي أخضر', price: 35, image: 'https://readdy.ai/api/search-image?query=green%20tea%20box%20package%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20high%20quality%20commercial%20photo%2C%20centered%20composition%2C%20soft%20lighting%2C%20realistic%20details&width=200&height=200&seq=prod6&orientation=squarish', rating: 4.8, sales: 1340 }
  ];

  return (
    <div className="min-h-screen bg-[#F6F6F6] pb-20" style={{ fontFamily: 'Cairo, sans-serif' }}>
      {/* Top Navigation */}
      <div className="fixed top-0 left-0 right-0 bg-gradient-to-r from-[#0D47A1] to-[#1976D2] z-50 shadow-lg">
        <div className="px-4 py-4">
          <div className="flex items-center justify-between mb-3">
            <button className="w-10 h-10 flex items-center justify-center">
              <i className="ri-menu-line text-white text-2xl"></i>
            </button>
            <h1 className="text-white text-lg font-bold">طلبات الجملة والتجزئة</h1>
            <button className="w-10 h-10 flex items-center justify-center relative">
              <i className="ri-notification-line text-white text-2xl"></i>
              <span className="absolute top-1 right-1 w-2 h-2 bg-[#FF8F00] rounded-full"></span>
            </button>
          </div>
          
          {/* Search Bar */}
          <div className="relative">
            <input
              type="text"
              placeholder="ابحث عن منتج..."
              className="w-full pr-12 pl-4 py-3 rounded-full bg-white/20 backdrop-blur-sm text-white placeholder-white/70 border border-white/30 focus:outline-none focus:bg-white/30 transition-all"
            />
            <i className="ri-search-line absolute right-4 top-1/2 -translate-y-1/2 text-white text-xl"></i>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="pt-32 px-4">
        {/* Slider */}
        <div className="relative mb-6 rounded-2xl overflow-hidden shadow-lg">
          <div className="relative h-44 overflow-hidden">
            {slides.map((slide, index) => (
              <div
                key={index}
                className={`absolute inset-0 transition-transform duration-500 ease-out ${
                  index === currentSlide ? 'translate-x-0' : index < currentSlide ? '-translate-x-full' : 'translate-x-full'
                }`}
              >
                <img src={slide.bg} alt={slide.title} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex flex-col justify-end p-5">
                  <h2 className="text-white text-xl font-bold mb-1">{slide.title}</h2>
                  <p className="text-white/90 text-sm">{slide.subtitle}</p>
                </div>
              </div>
            ))}
          </div>
          
          {/* Slider Dots */}
          <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2">
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`h-1.5 rounded-full transition-all ${
                  index === currentSlide ? 'w-6 bg-white' : 'w-1.5 bg-white/50'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Categories */}
        <div className="mb-6">
          <h2 className="text-[#212121] text-lg font-bold mb-4">الأقسام</h2>
          <div className="grid grid-cols-3 gap-3">
            {categories.map((category, index) => (
              <button
                key={index}
                onClick={() => navigate('/products')}
                className="bg-white rounded-2xl p-4 shadow-sm active:scale-95 transition-transform"
              >
                <div className="w-16 h-16 mx-auto mb-2 rounded-xl overflow-hidden">
                  <img src={category.image} alt={category.name} className="w-full h-full object-cover" />
                </div>
                <p className="text-[#212121] text-xs font-medium text-center">{category.name}</p>
              </button>
            ))}
          </div>
        </div>

        {/* Best Selling Products */}
        <div className="mb-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-[#212121] text-lg font-bold">الأكثر مبيعاً</h2>
            <button onClick={() => navigate('/products')} className="text-[#0D47A1] text-sm font-medium">
              عرض الكل
            </button>
          </div>
          
          <div className="grid grid-cols-2 gap-3" data-product-shop>
            {products.map((product) => (
              <button
                key={product.id}
                onClick={() => navigate(`/product/${product.id}`)}
                className="bg-white rounded-2xl overflow-hidden shadow-sm active:scale-95 transition-transform"
              >
                <div className="relative h-40 bg-gray-100">
                  <img src={product.image} alt={product.name} className="w-full h-full object-cover object-top" />
                  <div className="absolute top-2 right-2 bg-[#4CAF50] text-white text-xs font-bold px-2 py-1 rounded-full">
                    متوفر
                  </div>
                </div>
                <div className="p-3">
                  <h3 className="text-[#212121] text-sm font-bold mb-1 text-right line-clamp-1">{product.name}</h3>
                  <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center gap-1">
                      <i className="ri-star-fill text-[#FF8F00] text-xs"></i>
                      <span className="text-gray-600 text-xs">{product.rating}</span>
                    </div>
                    <span className="text-gray-500 text-xs">{product.sales} مبيعات</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-[#0D47A1] text-lg font-bold">{product.price} ر.س</span>
                    <button className="w-8 h-8 bg-[#0D47A1] rounded-full flex items-center justify-center">
                      <i className="ri-add-line text-white text-lg"></i>
                    </button>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Wholesale Banner */}
        <div className="bg-gradient-to-r from-[#FF8F00] to-[#F57C00] rounded-2xl p-6 shadow-lg mb-6">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-white text-xl font-bold mb-2">طلبات الجملة</h3>
              <p className="text-white/90 text-sm mb-4">أسعار خاصة للتجار</p>
              <button
                onClick={() => navigate('/wholesale')}
                className="bg-white text-[#FF8F00] px-6 py-2 rounded-full font-bold text-sm shadow-lg active:scale-95 transition-transform"
              >
                اطلب الآن
              </button>
            </div>
            <div className="w-24 h-24 flex items-center justify-center">
              <i className="ri-box-3-fill text-white text-6xl opacity-30"></i>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Navigation */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
        <div className="grid grid-cols-5 h-16">
          <button className="flex flex-col items-center justify-center gap-1">
            <i className="ri-home-5-fill text-[#0D47A1] text-xl"></i>
            <span className="text-[#0D47A1] text-[0.625rem] font-medium">الرئيسية</span>
          </button>
          <button onClick={() => navigate('/products')} className="flex flex-col items-center justify-center gap-1">
            <i className="ri-grid-line text-gray-400 text-xl"></i>
            <span className="text-gray-400 text-[0.625rem]">المنتجات</span>
          </button>
          <button onClick={() => navigate('/cart')} className="flex flex-col items-center justify-center gap-1 relative">
            <i className="ri-shopping-cart-line text-gray-400 text-xl"></i>
            <span className="text-gray-400 text-[0.625rem]">السلة</span>
            <span className="absolute top-1 right-1/2 translate-x-3 w-4 h-4 bg-[#FF8F00] text-white text-[0.5rem] font-bold rounded-full flex items-center justify-center">3</span>
          </button>
          <button onClick={() => navigate('/orders')} className="flex flex-col items-center justify-center gap-1">
            <i className="ri-file-list-line text-gray-400 text-xl"></i>
            <span className="text-gray-400 text-[0.625rem]">الطلبات</span>
          </button>
          <button onClick={() => navigate('/profile')} className="flex flex-col items-center justify-center gap-1">
            <i className="ri-user-line text-gray-400 text-xl"></i>
            <span className="text-gray-400 text-[0.625rem]">الحساب</span>
          </button>
        </div>
      </div>
    </div>
  );
}